import {Input, iconTypes} from "./Input.component";

export {Input, iconTypes};
